import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DatePipe} from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {JJMMYYYY_FORMAT_PROVIDER} from '../../../helpers/jjmmyyy-format.helper';
import { GestionnaireService } from '../gestionnaire.service';
import { FichePatient, PatientAffiliatedResponse, PatientResponse } from '../FichePatient.model';

// the second parameter 'fr' is optional
registerLocaleData(localeFr, 'fr');

export interface DialogData {
  patientKey: number;
}

@Component({
  selector: 'oap-detail-patient',
  templateUrl: './detail-patient.component.html',
  styleUrls: ['./detail-patient.component.scss'],
  providers: [...JJMMYYYY_FORMAT_PROVIDER]
})
export class DetailPatientComponent implements OnInit {
  fichePatient: Observable<FichePatient>;

  showSansMutuelle = false;
  accepteRecevoirEmail = true;
  noPatientAttached = false;

  labelPatientPrincipal: string;

  currentPatient: PatientResponse;
  attachedPatients: PatientAffiliatedResponse[];
  currentPatientPrincipal: boolean;
  patientPrincipal: PatientResponse | undefined;

  datePipe = new DatePipe('fr');

  public mask = [/[1-4,7-8]/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /[0-9A-B]/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/];
  public maskTel = [/\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/];

  constructor(public dialogRef: MatDialogRef<DetailPatientComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private gestionnaireService: GestionnaireService) {
    }

  ngOnInit() {
    const datePipe = new DatePipe('fr');

    this.fichePatient = this.gestionnaireService.getFichePatient(this.data.patientKey).pipe(
      tap(res => {
          this.currentPatient = res.currentPatient;
          this.attachedPatients = res.attachedPatient;
          this.currentPatientPrincipal = res.currentPatientPrincipal;
          this.patientPrincipal = res.patientPrincipal;

          if (res.currentPatientPrincipal) {
            this.labelPatientPrincipal =  '( Principal )';
            this.noPatientAttached = res.attachedPatient.length === 0;
          }
          this.showSansMutuelle = res.currentPatient.patientSansMutuelle;
          this.accepteRecevoirEmail = res.currentPatient.accepteRecevoirEmail;
        }
      ));
  }

  transformBoolean(value: boolean) {
    if (value) {
      return 'Oui';
    }
    return 'Non';
  }

  closeDialog() {
    return this.dialogRef.close();
  }

}
